<template>
  <div
    :class="{
      [$style.baseSelect]: true,
      [$style.halfWidth]: isHalf,
      [$style.marginSmall]: input.marginSize === 'small',
      [$style.marginMedium]: input.marginSize === 'medium',
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone
    }"
  >
    <!-- text -->
    <label
      v-if="input.label"
      :class="{
        [$style.label]: true,
        [$style.labelBig]: input.labelSize === 'big'
      }"
      >{{ input.label }}
    </label>

    <!-- wrapper -->
    <div :class="$style.selectWrapper">
      <!-- checked icon -->
      <img
        :src="getCheckedIcon"
        alt="question icon"
        :class="$style.checkedIcon"
        v-if="selectedValue && input.checkIcon !== false"
      />
      <select
        v-model="$v.selectedValue.$model"
        @change="onChange()"
        :class="{
          [$style.select]: true,
          [$style.selectNewDesign]: isNewDesign,
          [$style.invalid]: isInvalid,
          [$style.placeholder]: !selectedValue,
          [$style.center]: isCentered && selectedValue
        }"
      >
        <!-- custom placeholder -->
        <option disabled value="" v-if="input.placeholder">{{
          input.placeholder
        }}</option>
        <!-- options -->
        <option
          v-for="(option, index) in input.options"
          :key="index"
          :value="option.value"
          :selected="selectedValue === option.value"
          >{{ option.label }}</option
        >
      </select>
    </div>
    <!-- error message -->
    <p v-if="isInvalid && input.validationBox" :class="$style.errorMessage">
      {{ input.validations.message }}
    </p>
  </div>
</template>

<script>
import store from '@/store'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    input: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedValue: '',
      isInvalid: false
    }
  },
  mixins: [validationMixin],
  validations() {
    if (this.input.validations) {
      return {
        selectedValue: {
          required: this.input.validations.required ? required : ''
        }
      }
    }
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    // note: new design
    getCheckedIcon() {
      if (this.isNewDesign) {
        return require('../../assets/images/checked_new.svg')
      } else {
        return require('../../assets/images/checked.svg')
      }
    },
    vuexInputValidate() {
      return store.state.inputValidate
    },
    isHalf() {
      return this.input.width === 'half'
    },
    isCentered() {
      return this.input.style === 'center'
    },
    el() {
      return store.state.el
    }
  },
  methods: {
    onChange() {
      this.isInvalid =
        this.$v.selectedValue.$invalid && this.$v.selectedValue.$anyDirty
          ? true
          : false
      const data = {
        slideName: this.input.slideName,
        formName: this.input.formName,
        value: this.selectedValue,
        name: this.input.name,
        isInvalid: this.isInvalid
      }
      this.$emit('select', data)
    }
  },
  watch: {
    vuexInputValidate() {
      if (this.vuexInputValidate) {
        this.isInvalid = this.$v.selectedValue.$invalid
      }
    }
  },
  created() {
    this.selectedValue = this.input.selectedValue
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';

.baseSelect {
  width: 480px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: $color_font_2;
  margin-bottom: 66px;
  -webkit-appearance: none;
}

// prop
.halfWidth {
  width: 380px;
}

// prop
.marginSmall {
  margin-bottom: 22px;
}

// prop
.marginMedium {
  margin-bottom: 30px;
  .label {
    margin-bottom: 10px;
  }
}

// prop
.label {
  position: relative;
  margin-bottom: 19px;
  font-size: 18px;
}

// prop
.labelBig {
  position: relative;
  margin-bottom: 19px;
  font-size: 28px;
}

.questionIconBox {
  position: absolute;
  top: -20px;
  right: -40px;
  width: 27px;
  height: 33px;
  background-color: $color_green_1;
}

.questionIcon {
  padding-top: 4px;
  height: 20px;
  width: 17px;
}

.selectWrapper {
  width: 100%;
  position: relative;
}

.checkedIcon {
  position: absolute;
  top: 12px;
  left: 14px;
  width: 24px;
  z-index: 100;
}

.select {
  cursor: pointer;
  width: 100%;
  height: 50px;
  border: 2px solid $color_grey_3;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  font-size: 18px;
  color: $color_font_3;
  padding-left: 15px;
  font-family: inherit;
  -webkit-appearance: none;
  background-color: $color_bg_light;
  position: relative;
}

// note: new design
.selectNewDesign {
  border: 2px solid $color_border_new;
}

.select:focus {
  outline: none;
  border: 2px solid $color_green_2;
}

// note: new design
.selectNewDesign:focus {
  outline: none;
  border: 2px solid $color_border_dark_new;
}

.select::-ms-expand {
  display: none; /* Remove default arrow in Internet Explorer 10 and 11 */
}

.select {
  background-image: linear-gradient(45deg, transparent 50%, $color_grey_2 50%),
    linear-gradient(135deg, $color_grey_2 50%, transparent 50%),
    linear-gradient(to right, transparent, transparent);
  background-position: calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}

// note: new design
.selectNewDesign {
  background-image: linear-gradient(
      45deg,
      transparent 50%,
      $color_border_new 50%
    ),
    linear-gradient(135deg, $color_border_new 50%, transparent 50%),
    linear-gradient(to right, transparent, transparent);
  background-position: calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}

// prop
.center {
  padding-left: 50px;
}

.placeholder {
  color: $color_font_4;
}

.invalid {
  border: 2px solid $color_error;
}

.errorMessage {
  width: 100%;
  display: block;
  color: white;
  line-height: 1.2;
  font-size: 13px;
  background-color: $color_error;
  padding: 5px 15px;
  text-align: left;
}

// note: PORT
.land {
  // prop
  &.halfWidth {
    width: 49%;
  }
}

// note: PORT
.port {
  width: 385px;
}

// note: PHONE
.phone {
  &.halfWidth {
    width: 100%;
  }
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  .label {
    font-size: 18px;
  }
}
</style>
